import React from 'react';
import { Stethoscope } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center items-center">
          <Stethoscope className="h-8 w-8 mr-2 text-blue-400" />
          <span className="text-2xl font-bold">MedRep CRM</span>
        </div>
        <div className="mt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} MedRep CRM. All rights reserved.</p>
          <p className="mt-2">The ultimate tool for pharmaceutical sales excellence.</p>
        </div>
      </div>
    </footer>
  );
}
